import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'

const TitleSection = () => {
    const { translate } = useTranslate()

    return (
        <Stack alignItems="center" gap={3}>
            <Typography variant="h1" color="primary.main" textAlign={'center'} textTransform={'uppercase'}>
                {translate('purchase_tickets')}
            </Typography>
            <Typography
                variant="h4"
                color="primary.main"
                textAlign={'center'}
                lineHeight={'32px'}
                dangerouslySetInnerHTML={{ __html: translate('purchase_tickets_description') }}
            />
        </Stack>
    )
}

export default TitleSection
